import { ModuleWithProviders, inject, provideAppInitializer } from '@angular/core';
import { DEFAULT_PROTOCOL_ID, ProtocolRegistry } from '@core/shared/protocol';
import { DevConsoleProtocolLogger } from './dev-console.logger';
import { ProtocolService } from './protocol.service';
import { injectableProtocolFactory } from './protocol-factory';
import { DEFAULT_PROTOCOL } from './token';
import * as i0 from "@angular/core";
export let CoreProtocolModule = /*#__PURE__*/(() => {
  class CoreProtocolModule {
    static forRoot() {
      return {
        ngModule: CoreProtocolModule,
        providers: [ProtocolRegistry, ProtocolService, injectableProtocolFactory(DEFAULT_PROTOCOL, DEFAULT_PROTOCOL_ID, [DevConsoleProtocolLogger]),
        // use an empty app initializer depending on DEFAULT_PROTOCOL to force-create the protocol
        provideAppInitializer(() => {
          inject(DEFAULT_PROTOCOL);
        })]
      };
    }
    static {
      this.ɵfac = function CoreProtocolModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreProtocolModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreProtocolModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({});
    }
  }
  return CoreProtocolModule;
})();